import { FileExtended } from "ui/components/FileUpload/FileDropZone/types";
import { FleetDocumentUpload } from "../documents/types";
import { transformInvoiceIncoming } from "services/api/finance/incoming-invoices/transformations";
import {
  FleetVehicleExpense,
  FleetVehicleExpenseEditFormValues,
  FleetVehicleExpenseRow,
  FleetVehicleExpenseUploadRow,
} from "./types";


export const transformFleetVehicleExpenseRow = (
  res: any
): FleetVehicleExpenseRow => {
  return {
    id: res.id,
    name: res.name,
    description: res.description,
    expenseDate: res.expenseDate,
    paymentDate: res.paymentDate,
    amount: res.amount,
    taxAmount: res.taxAmount,
    vehicle: res.vehicle ?? null,
    expenseTypeId: res.expenseTypeId,
    expenseTypeName: res.expenseTypeName ?? null,
    expenseTypeCode: res.expenseTypeCode ?? null,
    officeId: res.officeId ?? null,
    officeName: res.officeName ?? null,
    childRows: res.uploads ? res.uploads.map((u: any) => transformFleetVehicleExpenseUploadRow(u, res)): [],
    invoiceIncoming: res.invoiceIncoming ? transformInvoiceIncoming(res.invoiceIncoming) : null,
  };
};



export const transformFleetVehicleExpenseOnCreate = (
  vehicleId: string,
  formValues: FleetVehicleExpenseEditFormValues,
  uploads: FleetDocumentUpload []
): any => ({
  vehicleId: vehicleId || null,
  expenseTypeId: formValues.expenseTypeId,
  officeId: formValues.officeId,
  name: formValues.name,
  description: formValues.description,
  expenseDate: formValues.expenseDate,
  paymentDate: formValues.paymentDate,
  amount: formValues.amount,
  taxAmount: formValues.taxAmount,
  uploadIds: uploads.map((u) => u.id),
  // Popunjeno samo kad trošak nastaje uz premještaj.
  vehicleLocationId: formValues.vehicleLocationId ?? null,
});

export const transformFleetVehicleExpenseOnUpdate = (
  vehicleId: string,
  formValues: FleetVehicleExpenseEditFormValues,
  uploads: FleetDocumentUpload []
): any => ({
  expenseTypeId: formValues.expenseTypeId,
  officeId: formValues.officeId,
  name: formValues.name,
  description: formValues.description,
  expenseDate: formValues.expenseDate,
  paymentDate: formValues.paymentDate,
  amount: formValues.amount,
  taxAmount: formValues.taxAmount,
  uploadIds: uploads.map((u) => u.id),
});

export const transformFleetVehicleExpense = (res: any): FleetVehicleExpense => {
  return {
    id: res.id,
    vehicle: res.vehicle ?? null,
    expenseTypeId: res.expenseTypeId,
    expenseTypeName: res.expenseTypeName ?? null,
    officeId: res.officeId ?? null,
    name: res.name,
    description: res.description,
    expenseDate: res.expenseDate,
    paymentDate: res.paymentDate,
    amount: res.amount,
    taxAmount: res.taxAmount,
    uploads: res.uploads,
  };
};

export const transformFleetVehicleExpenseEditFormValues = (
  res: FleetVehicleExpense
): FleetVehicleExpenseEditFormValues => {

  const files: FileExtended[] = [];

  if (res.uploads && Array.isArray(res.uploads)) {
    res.uploads.forEach((u) => {
      const dummyBlob = new Blob([""], { type: u.contentType });

      const fakeFile: FileExtended = Object.assign(
        new File([dummyBlob], u.originalFileName, {
          type: u.contentType,
          lastModified: new Date(u.created).getTime(),
        }),
        {
          id: u.id,
          url: u.url,
          isNew: false,
        }
      );

      files.push(fakeFile);
    });
  }

  return {
    id: res.id,
    vehicleId: res.vehicle?.id ?? null,
    expenseTypeId: res.expenseTypeId ?? null,
    officeId: res.officeId ?? null,
    name: res.name,
    description: res.description,
    expenseDate: res.expenseDate,
    paymentDate: res.paymentDate,
    amount: res.amount,
    taxAmount: res.taxAmount,
    files,
  };
};



export const transformFleetVehicleExpenseUploadRow = (
  res: any, parent: any
): FleetVehicleExpenseUploadRow => {
  return {
    vehicleExpenseId: parent.id,
    id: res.id,
    originalFileName: res.originalFileName,
    created: res.created,
    url: res.url,
  };
};


